<template><div><h2>Alert</h2>
<ul>
<li>[feature] Add prop:content</li>
</ul>
<h2>Cell</h2>
<ul>
<li>[feature] Support prop:is-loading</li>
</ul>
<h2>Datetime</h2>
<ul>
<li>[fix] render picker on nextTick #1180</li>
</ul>
<h2>Scroller</h2>
<ul>
<li>[fix] Fix issue when redirecting on scrolling #1187</li>
<li>[fix] Fix resize listener not being destroyed #1183</li>
</ul>
<h2>Swipeout</h2>
<ul>
<li>[fix] Fix cannot scroll when disabled</li>
<li>[fix] Fix unable to trigger click event when disabled on android</li>
</ul>
<h2>XIcon</h2>
<ul>
<li>[enhance] Support all attributes #1147</li>
</ul>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// next_en-278.vue?ec0af486